module.exports = __webpack_public_path__ + "img/allthat_home_banner_wonju.2bc12264.png";